import React from 'react';
import { servicesData } from '../../data/mock';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  const scrollToContactWithService = (serviceId) => {
    // Map service IDs to form values
    const serviceToFormValue = {
      'flights': 'flights',
      'cruises': 'cruises',
      'hotels': 'hotels',
      'itineraries': 'itinerary'
    };
    
    // Dispatch custom event with selected service
    const event = new CustomEvent('serviceSelected', { 
      detail: { tripType: serviceToFormValue[serviceId] || serviceId }
    });
    window.dispatchEvent(event);
    
    // Scroll to contact section
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="bg-white py-16 sm:py-24 lg:py-32">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <p
            className="text-[#c9a96e] text-[10px] sm:text-[11px] tracking-[0.3em] uppercase mb-3 sm:mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            What We Offer
          </p>
          <h2
            className="text-[#0a1628] text-2xl sm:text-3xl md:text-4xl font-light mb-4 sm:mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Premium Travel Services
          </h2>
          <p
            className="text-[#4a5568] text-sm sm:text-base max-w-xl mx-auto font-light px-2"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Crafted experiences that match your vision, style, and aspirations.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className="group relative overflow-hidden cursor-pointer"
              onClick={() => scrollToContactWithService(service.id)}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/90 via-[#0a1628]/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 lg:p-8">
                <h3
                  className="text-white text-lg sm:text-xl lg:text-2xl font-light mb-1 sm:mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {service.title}
                </h3>
                <p
                  className="text-white/70 text-xs sm:text-sm font-light mb-3 sm:mb-4 leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {service.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-1 sm:gap-2 mb-3 sm:mb-4">
                  {service.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="text-[8px] sm:text-[10px] text-white/60 px-2 sm:px-3 py-1 border border-white/20 uppercase tracking-wider"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                <div className="flex items-center gap-2 text-[#c9a96e] text-[10px] sm:text-[11px] uppercase tracking-[0.15em] group-hover:gap-3 transition-all duration-300">
                  <span>Enquire</span>
                  <ArrowRight size={12} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
